import React from "react";

const HorizontalBarChartSkeleton: React.FC = () => {
	return (
		<div className="w-full h-full rounded-lg bg-gray-100 p-6 animate-pulseOpacity">
			{/* Chart container */}
			<div className="h-[90%] w-full rounded-md flex items-center justify-center text-gray-400 animate-pulseOpacity">
				{/* Chart icon */}
				<svg width="64" height="64" viewBox="0 0 64 64" fill="none" className="text-gray-400">
					{/* X & Y axis */}
					<line x1="12" y1="8" x2="12" y2="52" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
					<line x1="12" y1="52" x2="56" y2="52" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />

					{/* Horizontal bars */}
					<rect x="16" y="14" width="28" height="6" rx="2" fill="currentColor" />
					<rect x="16" y="26" width="36" height="6" rx="2" fill="currentColor" />
					<rect x="16" y="38" width="22" height="6" rx="2" fill="currentColor" />
				</svg>
			</div>
		</div>
	);
};

export default HorizontalBarChartSkeleton;
